import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledDealflowEntitiesTableViews
  from 'components/organisms/TableViews/DealflowEntitiesTableViews/DealflowEntitiesTableViews.styles';
import {useCollectionGet} from 'services/collection/collection.hooks';
import {useAuthClient} from 'components/organisms/Providers/AuthProvider/AuthProvider';

const DealflowEntitiesTableViews = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DealflowEntitiesTableViews');

  const client = useAuthClient();
  const universeCollection = useCollectionGet({collectionId: client?.universeCollectionId},
    {enabled: Boolean(client?.universeCollectionId)})?.data;

  return <StyledDealflowEntitiesTableViews ref={ref} {...innerProps}
                                           collection={universeCollection}>
    {innerProps.children}
  </StyledDealflowEntitiesTableViews>
});

DealflowEntitiesTableViews.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DealflowEntitiesTableViews;
